const manage_incident_filter_helper = {
  set_incident_filter(filter_name, value) {
    const current_value = Reflect.get(this.incident_filters, filter_name);
    Reflect.set(this.incident_filters, filter_name, current_value === value ? "" : value);
    this.apply_incident_filters();
  },
  apply_and_close_incident_filters() {
    this.apply_incident_filters();
    Reflect.set(this, "incident_filter_panel_open", false);
  },
  toggle_incident_filter_panel() {
    Reflect.set(this, "incident_filter_panel_open", !this.incident_filter_panel_open);
    if (this.incident_filter_panel_open) this.$nextTick(this.position_incident_filter_panel);
  },
  get_desktop_filter_panel_position(toggle_rect, panel_width) {
    const viewport_padding = 12;
    const maximum_left = window.innerWidth - panel_width - viewport_padding;
    const left = Math.min(Math.max(viewport_padding, toggle_rect.right - panel_width), maximum_left);
    const default_top = toggle_rect.bottom + 10;
    const default_max_height = window.innerHeight - default_top - viewport_padding;
    const use_full_height = default_max_height < 360;
    return {
      top: use_full_height ? viewport_padding : default_top,
      left,
      max_height: use_full_height ? window.innerHeight - (viewport_padding * 2) : default_max_height,
    };
  },
  get_mobile_filter_panel_position() {
    const viewport_padding = 12;
    const top = 72;
    return { top, left: viewport_padding, max_height: window.innerHeight - top - viewport_padding };
  },
  position_incident_filter_panel() {
    if (!this.incident_filter_panel_open) return;
    const toggle = Reflect.get(this.$refs, "incidentFilterToggle");
    if (!toggle) return;

    const viewport_padding = 12;
    const panel_width = Math.min(540, window.innerWidth - (viewport_padding * 2));
    const position = window.innerWidth <= 575
      ? this.get_mobile_filter_panel_position()
      : this.get_desktop_filter_panel_position(toggle.getBoundingClientRect(), panel_width);
    Reflect.set(this, "incident_filter_panel_position", {
      top: `${position.top}px`,
      left: `${position.left}px`,
      width: `${panel_width}px`,
      maxHeight: `${position.max_height}px`,
    });
  },
};

export default manage_incident_filter_helper;
